import Cookies from 'js-cookie';
/*
 * 设置cookies
 * */
export function getCookies(key: string) {
    return Cookies.get(key);
}
/*
 * 设置Cookies
 * */
export function setCookies(key: string, value: string, expiresTime?: number) {
    return Cookies.set(key, value);
}
/*
 * 移除Cookies
 * */
export function removeCookies(key?: string) {
    if (!key) {
        const cookieList = Cookies.get();
        console.log('cookieList', cookieList);
        if (cookieList) {
            Object.keys(cookieList).map((item: string) => {
                Cookies.remove(item);
            });
        }
    } else {
        return Cookies.remove(key);
    }
}
